import styled from "styled-components";
import {motion} from "framer-motion";

const StyledDropdownItem = styled.div`
  padding: 0 10px;
  border-bottom: 1px solid ${props => props.theme.colors.invertedPrimary};
`

const motionItem = {
  open: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
      ease: [0.6, 0.05, -0.01, 0.9]
    }
  },
  closed: {
    opacity: 0,
    x: -50,
    transition: {
      duration: 0.2,
      ease: [0.6, 0.05, -0.01, 0.9]
    }
  }
}

const CollapseItem = ({ children, ...props }) => {
  return (
    <StyledDropdownItem
      as={motion.div}
      variants={motionItem}
      {...props}
    >
      {children}
    </StyledDropdownItem>
  );
};

export default CollapseItem;